import React, { useEffect, useState } from 'react';
import './contact.css';
import squreImg from '../../assets/bib.gif';
import SouthWestIcon from '@mui/icons-material/SouthWest';
import SouthEastIcon from '@mui/icons-material/SouthEast';
import Version from '../version/Version';
import Socials from '../socials/Socials';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';


function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [subjectError, setSubjectError] = useState('');
  const [messageError, setMessageError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false);
  const [successPopValue, setSuccessPopValue] = useState(0);
  const [showError, setShowError] = useState(false);

  function handleNameChange(event) {
    setName(event.target.value);
    setSuccessMessage(null);
    if (!event.target.value) {
      setNameError('Please enter your name');
    } else {
      setNameError('');
    }
  }

  function handleEmailChange(event) {
    setEmail(event.target.value);
    setSuccessMessage(null);
    if (!event.target.value.match(/^[A-Za-z._\-0-9]*[@][A-Za-z]*[.][a-z]{2,4}$/)) {
      setEmailError('Please enter a valid email.');
    } else {
      setEmailError('');
    }
  }

  function handleSubjectChange(event) {
    setSubject(event.target.value);
    setSuccessMessage(null);
    if (!event.target.value) {
      setSubjectError('Please enter a subject');
    } else {
      setSubjectError('');
    }
  }

  function handleMessageChange(event) {
    setMessage(event.target.value);
    setSuccessMessage(null);
    if (!event.target.value) {
      setMessageError('Please enter a message');
    } else {
      setMessageError('');
    }
  }

  const encode = (data) => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');
  }

  function sendEmail(e) {
    e.preventDefault();
    let hasError = false;
    if (!name) {
      setNameError('Please enter your name');
      hasError = true;
    }
    if (!email.match(/^[A-Za-z._\-0-9]*[@][A-Za-z]*[.][a-z]{2,4}$/)) {
      setEmailError('Please enter a valid email');
      hasError = true;
    }
    if (!subject) {
      setSubjectError('Please enter a subject');
      hasError = true;
    }
    if (!message) {
      setMessageError('Please enter a message');
      hasError = true;
    }
    if (!hasError) {
      setSubmitting(true);
      const data = {
        name,
        email,
        subject,
        message
      };
      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({'form-name': 'contactForm', ...data})
      })
        .then(() => {
          setSubmitting(false);
          setSuccessMessage('Thank you! Your message has been sent.');
          e.target.reset();
          setName('');
          setEmail('');
          setSubject('');
          setMessage('');
          setShowSuccessPopUp(true);
          setShowError(false);
          setTimeout(() => {
            setShowSuccessPopUp(false);
          }, 3000);
        })
        .catch(error => {
          setSubmitting(false);
          setSuccessMessage('There was an error sending your message. Please try again later.');
          console.error(error);
        });
    }else{
      setSuccessMessage('Please enter necessary details!');
      setShowSuccessPopUp(true);
      setShowError(true);
      setTimeout(() => {
        setShowSuccessPopUp(false);
      }, 3000);
    }
  }

  useEffect(()=>{
    if(showSuccessPopUp){
      const interval = setInterval(() => {
                setSuccessPopValue(prevScale => Math.min(prevScale + 0.01, 1));
            }, 10);
        return () => clearInterval(interval);
        } else {
            const interval = setInterval(() => {
                setSuccessPopValue(prevScale => Math.max(prevScale - 0.01, 0));
            }, 10);
        return () => clearInterval(interval);
    }
  },[showSuccessPopUp])

  return (
    <div className='contact slide-in-top-animation'>
        <div className="contact-container">
          <div className="contact-arrow">
            <SouthEastIcon sx={{ fontSize: `calc(clamp(5.5em, 5vw, 8em) * .6)` }}/>
          </div>
            <div className="contact-top">
              <div className="contact-top-left">
                <h2>Let's Get in touch</h2>
              </div>
              <div className="contact-top-right">
                <img src={squreImg} alt="" />
              </div>
            </div>
            <div className="contact-bot">
              <form action="" className="contact-form" onSubmit={sendEmail} method='post' name='contactForm'>
              <input type='hidden' name='form-name' value='contactForm' />
                <div className="input-card">
                  <div className="input-box">
                    <h3>01</h3>
                    <label htmlFor="">What's your name?</label>
                    <input autoComplete="off" name='name' type="text" placeholder='John Doe *' onChange={handleNameChange}/>
                    <p className='error-text'>{nameError}</p>
                  </div>
                </div>
                <div className="input-card">
                  <div className="input-box">
                    <h3>02</h3>
                    <label htmlFor="">What's your email?</label>
                    <input autoComplete="nope" name='email' type="text" placeholder='john@doe.com *' onChange={handleEmailChange}/>
                    <p className='error-text'>{emailError}</p>
                  </div>
                </div>
                <div className="input-card">
                  <div className="input-box">
                    <h3>04</h3>
                    <label htmlFor="">What topic are you talikng?</label>
                    <input autoComplete="nope" name='subject' type="text" placeholder='Web design, internship... *' onChange={handleSubjectChange}/>
                    <p className='error-text'>{subjectError}</p>
                  </div>
                </div>
                <div className="input-card">
                  <div className="input-box last-box">
                    <h3>05</h3>
                    <label htmlFor="">Your message</label>
                    <textarea name='message' rows="8" type="text" placeholder='Hello Bibhu, can you help me with...*' onChange={handleMessageChange}/>
                    <p className='error-text'>{messageError}</p>
                  </div>
                </div>
                <div className="contact-btn-arrow">
                  <SouthWestIcon sx={{ fontSize: `calc(clamp(3.5em, 5vw, 8em) * .5)` }}/>
                </div>
                <div className="contact-btn-reset">
                  <button type='reset'><AutorenewIcon sx={{ fontSize: `calc(clamp(4.5em, 5vw, 8em) * .5)` }}/></button>
                </div>
                <div className="contact-btn">
                  <div className="contact-btn-hover"></div>
                  {submitting ? (
                    <button disabled>Submitting...</button>
                  ) : (
                    <button type='submit'>Submit</button>
                  )}
                </div>
              </form>
            </div>
            <div className="sucess-pop-up" style={{ transform: `translateX(${successPopValue * 20}px)`, opacity: successPopValue }}>
              <div className="sucess-wrap">
                    <div className="sucess-pop-left" style={showError ? { color: 'red' } : { color: '#3ea30f' }}>
                      {showError ? <CancelIcon /> : <CheckCircleIcon />}
                    </div>
                    <div className="sucess-pop-right">
                      {successMessage}
                    </div>
              </div>
            </div>
        </div>
        <div className="bot-footer">
            <Version/>
            <hr />
            <Socials/>
        </div>
    </div>
  )
}

export default Contact